import { render, staticRenderFns } from "./poform.vue?vue&type=template&id=c03e4932&scoped=true&"
import script from "./poform.vue?vue&type=script&lang=js&"
export * from "./poform.vue?vue&type=script&lang=js&"
import style0 from "./poform.vue?vue&type=style&index=0&id=c03e4932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03e4932",
  null
  
)

export default component.exports